import styled from "styled-components/macro";

import { CssFlex } from "styles/helpers/layout";

export const StyledBottomBar = styled(CssFlex)`
  background: #fbfbfb;
  padding: 1rem 4rem;
`;
